import { render } from "./ProductBlock.vue?vue&type=template&id=c45ad29c&scoped=true"
import script from "./ProductBlock.vue?vue&type=script&lang=js"
export * from "./ProductBlock.vue?vue&type=script&lang=js"

import "./ProductBlock.vue?vue&type=style&index=0&id=c45ad29c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45ad29c"]])

export default __exports__